import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { UserProvider } from './contexts/UserContext';
render(<UserProvider data-id="element-6990">
    <App data-id="element-6991" />
  </UserProvider>, document.getElementById('root'));